import { Dispatch } from 'redux';
import { StakingActionEnum, StakingActionType } from '../reducers/new-staking-reducer';

export const StakingPoolActions = {
  setTransactionId: (transactionId: string) => {
    return async (dispatch: Dispatch<StakingActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_TRANSACTION_ID,
        payload: transactionId,
      });
    };
  },

  setSelectedPoolId: (id: string) => {
    return async (dispatch: Dispatch<StakingActionType>) => {
      dispatch({
        type: StakingActionEnum.SET_SELECTED_POOL_ID,
        payload: id,
      });
    };
  },
};
